module.exports = __webpack_public_path__ + "img/question-circle.d253ba22.svg";